(() => {
  const roots = document.querySelectorAll("[data-korede-soup]");

  const normalize = (value) => String(value || "")
    .replace(/\s+/g, "")
    .replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0xfee0))
    .replace(/の/g, "")
    .replace(/スープ/g, "")
    .replace(/プロテイン/g, "")
    .toLowerCase();

  const sameOption = (actual, expected) => {
    const a = normalize(actual);
    const b = normalize(expected);
    return a === b || a.includes(b) || b.includes(a);
  };

  const formatMoney = (amount) => {
    const value = Number(amount || 0) / 100;
    return new Intl.NumberFormat("ja-JP", {
      style: "currency",
      currency: "JPY",
      maximumFractionDigits: 0
    }).format(value);
  };

  roots.forEach((root) => {
    const dataNode = root.querySelector("[data-korede-variants-json]");
    if (!dataNode) return;

    let variants = [];
    try {
      variants = JSON.parse(dataNode.textContent || "[]");
    } catch (error) {
      variants = [];
    }

    const detailNode = root.querySelector("[data-korede-flavor-details-json]");
    let flavorDetails = {};
    try {
      flavorDetails = JSON.parse(detailNode?.textContent || "{}");
    } catch (error) {
      flavorDetails = {};
    }

    const capacityIndex = Number(root.dataset.capacityIndex || 0);
    const flavorIndex = Number(root.dataset.flavorIndex || -1);
    const hasFlavorOption = flavorIndex >= 0;
    const fixedFlavor = root.dataset.fixedFlavor || "";
    const defaultCapacity = root.dataset.defaultCapacity || "400g";
    const form = root.querySelector(".korede-soup__form");
    const variantInput = root.querySelector("[data-korede-variant-id]");
    const addButton = root.querySelector("[data-korede-add-button]");
    const selectedText = root.querySelector("[data-korede-selected-text]");
    const selectedFlavor = root.querySelector("[data-korede-selected-flavor]");
    const selectedComment = root.querySelector("[data-korede-selected-comment]");
    const priceNodes = root.querySelectorAll("[data-korede-price]");
    const sticky = root.querySelector("[data-korede-sticky]");
    const stickyButton = root.querySelector("[data-korede-sticky-button]");
    const stickySummary = root.querySelector("[data-korede-sticky-summary]");
    const optionButtons = root.querySelectorAll("[data-korede-option]");
    const detailButtons = root.querySelectorAll("[data-korede-detail-flavor]");
    const detailLabel = root.querySelector("[data-korede-detail-label]");
    const detailServing = root.querySelector("[data-korede-detail-serving]");
    const ingredientLabel = root.querySelector("[data-korede-ingredients-label]");
    const ingredientText = root.querySelector("[data-korede-ingredients-text]");
    const purchaseArea = root.querySelector("[data-korede-purchase-area]");

    const initialVariant = variants.find((variant) => String(variant.id) === String(variantInput?.value)) || variants[0];
    const state = {
      capacity: capacityIndex >= 0 ? initialVariant?.options?.[capacityIndex] || defaultCapacity : defaultCapacity,
      flavor: hasFlavorOption ? initialVariant?.options?.[flavorIndex] || fixedFlavor || "緑茶プロテイン" : fixedFlavor || "緑茶プロテイン",
      detailFlavor: hasFlavorOption ? initialVariant?.options?.[flavorIndex] || fixedFlavor || "緑茶プロテイン" : fixedFlavor || "緑茶プロテイン"
    };

    const getDetail = (flavor) => {
      const key = Object.keys(flavorDetails).find((name) => sameOption(name, flavor));
      return key ? { key, data: flavorDetails[key] } : null;
    };

    const getVariant = () => variants.find((variant) => {
      const capacity = variant.options?.[capacityIndex];
      const flavor = variant.options?.[flavorIndex];
      const capacityMatches = capacityIndex >= 0 ? sameOption(capacity, state.capacity) : true;
      const flavorMatches = hasFlavorOption ? sameOption(flavor, state.flavor) : true;
      return capacityMatches && flavorMatches;
    });

    const hasAvailableVariant = (type, value) => variants.some((variant) => {
      if (!variant.available) return false;
      if (type === "capacity") {
        if (capacityIndex < 0) return sameOption(value, defaultCapacity);
        return sameOption(variant.options?.[capacityIndex], value);
      }
      const capacity = variant.options?.[capacityIndex];
      const flavor = variant.options?.[flavorIndex];
      const capacityMatches = capacityIndex >= 0 ? sameOption(capacity, state.capacity) : true;
      const flavorMatches = hasFlavorOption ? sameOption(flavor, value) : true;
      return capacityMatches && flavorMatches;
    });

    const setButtonState = () => {
      optionButtons.forEach((button) => {
        const type = button.dataset.koredeOption;
        const value = button.dataset.value;
        const selected = sameOption(state[type], value);
        const available = hasAvailableVariant(type, value);

        button.classList.toggle("is-selected", selected);
        button.classList.toggle("is-unavailable", !available);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
        button.disabled = !available;
      });

      detailButtons.forEach((button) => {
        const selected = sameOption(state.detailFlavor, button.dataset.koredeDetailFlavor);
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    };

    const updateFlavorDetails = () => {
      const detail = getDetail(state.detailFlavor);
      if (!detail?.data) {
        if (detailLabel) detailLabel.textContent = state.detailFlavor;
        if (detailServing) detailServing.textContent = "1食分（粉末20g）あたり";
        if (ingredientLabel) ingredientLabel.textContent = state.detailFlavor;
        if (ingredientText) ingredientText.textContent = "原材料は商品表示をご確認ください。";

        root.querySelectorAll("[data-korede-nutrition]").forEach((node) => {
          node.textContent = "あとから更新";
        });
        return;
      }

      if (detailLabel) detailLabel.textContent = detail.data.label || detail.key;
      if (detailServing) detailServing.textContent = detail.data.serving || "1食分（粉末20g）あたり";
      if (ingredientLabel) ingredientLabel.textContent = detail.data.label || detail.key;
      if (ingredientText) ingredientText.textContent = detail.data.ingredients || "";

      root.querySelectorAll("[data-korede-nutrition]").forEach((node) => {
        const field = node.dataset.koredeNutrition;
        node.textContent = detail.data[field] || "";
      });
    };

    const update = () => {
      const variant = getVariant() || initialVariant;
      const isAvailable = Boolean(variant?.available);
      const price = formatMoney(variant?.price);
      const summary = `${state.capacity} / ${state.flavor}`;
      state.detailFlavor = state.flavor;

      if (variantInput && variant?.id) variantInput.value = variant.id;
      if (selectedText) selectedText.textContent = `選択中：${summary}`;
      if (selectedFlavor) selectedFlavor.textContent = `選択中：${state.flavor}`;
      if (selectedComment) {
        const selectedButton = Array.from(optionButtons).find((button) => {
          return button.dataset.koredeOption === "flavor" && sameOption(button.dataset.value, state.flavor);
        });
        selectedComment.textContent = selectedButton?.dataset.comment || "";
      }
      priceNodes.forEach((node) => {
        node.textContent = price;
      });
      if (stickySummary) stickySummary.textContent = `${summary}　${price}`;

      const addButtonText = addButton?.querySelector("span") || addButton;

      if (addButton) {
        addButton.disabled = !isAvailable;
        if (variantInput) variantInput.disabled = !isAvailable;
        if (addButtonText) addButtonText.textContent = isAvailable ? "カートに追加する" : "売り切れ";
      }
      if (stickyButton) {
        stickyButton.disabled = !isAvailable;
      }

      if (variant?.id && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({ path: url.toString() }, "", url.toString());
      }

      setButtonState();
      updateFlavorDetails();
    };

    optionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const type = button.dataset.koredeOption;
        const value = button.dataset.value;
        if (!type || !value || button.disabled) return;
        state[type] = value;
        update();
      });
    });

    detailButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const value = button.dataset.koredeDetailFlavor;
        if (!value) return;
        state.detailFlavor = value;
        setButtonState();
        updateFlavorDetails();
      });
    });

    if (stickyButton && form) {
      stickyButton.addEventListener("click", () => {
        if (addButton?.disabled) return;
        if (form.requestSubmit && addButton) {
          form.requestSubmit(addButton);
          return;
        }
        addButton?.click();
      });
    }

    const updateSticky = () => {
      if (!sticky || !purchaseArea) return;
      const isMobile = window.matchMedia("(max-width: 749px)").matches;
      const rect = purchaseArea.getBoundingClientRect();
      const shouldShow = isMobile && rect.bottom < 0;
      sticky.classList.toggle("is-visible", shouldShow);
      sticky.setAttribute("aria-hidden", shouldShow ? "false" : "true");
    };

    window.addEventListener("scroll", updateSticky, { passive: true });
    window.addEventListener("resize", updateSticky);

    update();
    updateSticky();
  });
})();
